module.exports = __webpack_public_path__ + "media/images/emblems/Ried-coat_of_arms-4d2b1b7b2cbf5d186401cf4572edc6ae.svg";